import type { ReactElement } from "react";

import { AgreementSigningPanel } from "./MsaSigningPanel";

/**
 * §D.2 Minting Master Agreement panel. The spec gives this subsection a
 * `verification` block, same as §D.1, so it renders as a provider-routed
 * signing panel rather than a field form — `MsaSigningPanel`'s shape:
 * description, a status card, then a single send CTA.
 *
 * The API uses the same agreement lifecycle as the MSA, with a separate
 * agreement type and envelope.
 */
export function OrderFormSigningPanel(_props: {
    displayNumber: string | null;
}): ReactElement {
    return (
        <AgreementSigningPanel
            agreementType="minting_master"
            agreementTitle="Minting Master Agreement"
        />
    );
}
